import { Tooltip } from "antd";
import React, { useState } from "react";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import SecondaryButton from "../../../../components/generic/buttons/SecondaryButton";
import AlertList from "./AlertList";

const Alert = ({ carePlanId, setShowAlert }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOnClick = async () => {
    setIsModalVisible(true);
  };

  const footerButtons = (
    <>
      <SecondaryButton
        buttonText="Close"
        handleOnClick={() => setIsModalVisible(false)}
      />
    </>
  );

  return (
    <>
      <Tooltip title="Alerts" placement="bottom">
        <>
          <SmartIcon
            iconKey="alert"
            handleIconClick={handleOnClick}
            color="var(--text-warning)"
          />
        </>
      </Tooltip>

      {isModalVisible && (
        <CustomModal
          isModalOpen={isModalVisible}
          footer={footerButtons}
          closeModal={setIsModalVisible}
          title="Alerts"
        >
          <AlertList carePlanId={carePlanId} setShowAlert={setShowAlert} />
        </CustomModal>
      )}
    </>
  );
};

export default Alert;
